import { oc } from '@orpc/contract';
import { photoSetInputSchema, photoSetOutputSchema } from '../schemas/documents.schemas.js';
/**
 * The photo-set indicator: which of the five availability photos and the licence are on file.
 *
 * **Informational only.** The old lifecycle's photo gate was removed with the lifecycle itself
 * (plan §3.1); nothing in the workspace is blocked by a missing photo.
 */
export const getDocumentPhotoSetContract = oc
    .route({
    method: 'GET',
    path: '/vehicles/{vehicleId}/documents/photo-set',
    tags: ['Documents'],
    summary: 'Which required photos and licence are on file (informational)',
})
    .input(photoSetInputSchema)
    .output(photoSetOutputSchema);
//# sourceMappingURL=get-document-photo-set.contract.js.map